import { render, staticRenderFns } from "./1100_Clicks_Happen.vue?vue&type=template&id=12000da8&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports